// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PUpSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PUpSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PUpSquareOutlined = function PUpSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PUpSquareOutlinedSvg
  }));
};

PUpSquareOutlined.displayName = 'PUpSquareOutlined';
export default React.forwardRef(PUpSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PUpSquareOutlined.js
// module id = 3714
// module chunks = 0